import React from 'react';
import HomeHeader from '../../../Shared/HomeHeader/HomeHeader';
import ScrollToTop from '../../../Shared/ScrollToTop/ScrollToTop';
import Aboutus from '../AboutUs/Aboutus';
import Blogs from '../Blogs/Blogs';
import ApplySection from '../BottomHomeSection/ApplySection';
import Company from '../Company/Company';
import Contact from '../Contact/Contact';
import Courses from '../Courses/Courses';
import CTA from '../CTA/CTA';
import Gallery from '../Gallery/Gallery';
import HeroHomeContent from '../HeroHomeContent/HeroHomeContent';
import HomeBanner from '../HomeBanner/HomeBanner';
import OurTeams from '../OurTeam/OurTeams';
import Services from '../Services/Services';
import ShortDetails from '../ShortDetails/ShortDetails';
import StudentSpeeches from '../StudentSpeech/StudentSpeeches';
import PreviousNextMethods from '../StudentSpeech/StudentSpeeches';
import Testimonials from '../Testiminials/Testimonials';
import VideoFree from '../Video/VideoFree';

const Home = () => {
    return (
        <div>
            {/* <HomeHeader/> */}
            {/* <Aboutus/> */}
            <ScrollToTop />
            <HeroHomeContent />
            {/* <HomeBanner /> */}
            {/* <div className='md:hidden mt-7'>
                <ApplySection />
            </div> */}
            <Courses />
            <Services />
            <ShortDetails />
            <OurTeams />
            {/* <StudentSpeech/> */}
            <StudentSpeeches />
            <VideoFree />
            {/* <Gallery /> */}
            {/* <Contact/> */}
            {/* <Testimonials/> */}
            {/* <PreviousNextMethods/> */}
            {/* <Company/> */}
            <Blogs />
            <CTA />
        </div>
    );
};

export default Home;